import template from './guest-header.html'
import './guest-header.scss'
import './responsive-menu.scss'

export default {
  template,
}



// WEBPACK FOOTER //
// ./src/app/screens/guest/components/guest-header/index.js